import { TABLE_ROWS_OPTIONS } from "@/ds";
import { isObrasSortField } from "@/modules/obras";
import type { ObrasSortField } from "@/modules/obras";
import {
  OBRAS_COLUMNS,
  OBRAS_LOADING_LABEL,
  OBRAS_NO_VALUE,
  OBRAS_ROWS_PER_PAGE_LABEL,
} from "../../obras-lista.constants";
import { GROW_COLUMNS, TAGS_COLUMNS } from "./obras-table.constants";
import { columnWidth } from "./obras-table.utils";
import type { ObrasTableProps, ObrasTableViewModel } from "./types-obras-table";

const ROWS_OPTIONS = [...TABLE_ROWS_OPTIONS];

/** O espaço sem quebra faz "Status da Obra" quebrar em "Status / da Obra", como no Figma (11161:217296). */
const ajustarRotulo = (label: string) => label.replace(" da Obra", " da Obra");

/** Tabela da Lista de Obras: o catálogo, as larguras e os rótulos que a tabela compartilhada recebe. */
export function useObrasTable({
  items,
  total,
  first,
  rows,
  status,
  errorMessage,
  search,
  filters,
  sort,
  settings,
  isMobile,
  onPage,
  onSort,
  onRetry,
  onClearSearch,
  onClearFilters,
}: ObrasTableProps): ObrasTableViewModel {
  return {
    items,
    total,
    status,
    errorMessage,
    first,
    rows,
    rowsOptions: ROWS_OPTIONS,
    onPage,
    sort,
    onSort,
    isSortField: (campo: unknown): campo is ObrasSortField => isObrasSortField(campo),
    settings,
    isMobile,
    catalogo: OBRAS_COLUMNS,
    larguraDaColuna: columnWidth,
    colunasQueCrescem: GROW_COLUMNS,
    colunasDeTags: TAGS_COLUMNS,
    ajustarRotulo,
    semValor: OBRAS_NO_VALUE,
    loadingLabel: OBRAS_LOADING_LABEL,
    rowsPerPageLabel: OBRAS_ROWS_PER_PAGE_LABEL,
    ariaLabel: "Obras",
    testId: "obras",
    search,
    filters,
    onRetry,
    onClearSearch,
    onClearFilters,
  };
}
